import { IChildEducationDetails } from '../types';

export const EMPTY_CHILD_EDUCATION_DETAILS: IChildEducationDetails = {
  occupation: undefined,
  training: '',
  education: '',
  employment: '',
  address: {
    address1: '',
    address2: '',
    town: '',
    postCode: '',
  },
};
